import { AppDate } from '../envTypes';

export enum SellerOnboardingStepType {
  PslPay = 'pslPay',
  StoreInfo = 'storeInfo',
  StoreReel = 'storeReel',
  BusinessLocation = 'businessLocation',
  ShippingOptions = 'shippingOptions',
  Inventory = 'inventory',
  Storefront = 'storefront',
  CommentChat = 'commentchat',
}

export interface SellerOnboardingCheckListItemConfig {
  required?: boolean;
  title?: string;
  description?: string;
  sort_order?: number;
}

export interface SellerOnboardingConfigParameters {
  enforced_after?: AppDate;
  limit_in_days?: number;
}

export interface SellerOnboardingCheckListConfig {
  force_completion_before_proceeding_in_app?: boolean;
  continue_button_text?: string;
  skip_button_text?: string;
  psl_pay?: SellerOnboardingCheckListItemConfig;
  store_info?: SellerOnboardingCheckListItemConfig;
  store_reel?: SellerOnboardingCheckListItemConfig;
  business_location?: SellerOnboardingCheckListItemConfig;
  shipping_options?: SellerOnboardingCheckListItemConfig;
  commentchat?: SellerOnboardingCheckListItemConfig;
  inventory_listings?: SellerOnboardingCheckListItemConfig & {
    min_listing_count?: number;
  };
  store_favorites?: SellerOnboardingCheckListItemConfig & {
    min_listing_count?: number;
  };
}

export type SellerOnboardingConfig = SellerOnboardingConfigParameters & {
  min_inventory_listing_count?: number;
  min_public_listing_count?: number;
  check_list_config?: {
    default?: SellerOnboardingCheckListConfig;
    business?: SellerOnboardingCheckListConfig &
      SellerOnboardingConfigParameters;
    creator?: SellerOnboardingCheckListConfig &
      SellerOnboardingConfigParameters;
  };
};

export type SellerOnboardingStepState = {
  finished?: boolean;
  finishedAt?: AppDate;
};
